import {RestService} from "@/services/rest/RestService";
import {ContentPreviewEndpointsApi} from "@/api/pharma-cms-content-preview";
import {
    ContentPreviewOverviewRestDto,
    ContentPreviewOverviewResultsRestDto
} from "@/api/pharma-cms-content-preview/models";
import {AxiosResponse} from "axios";

export class ContentPreviewRestService extends RestService {

    private apiService: ContentPreviewEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new ContentPreviewEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    /**
     * REST.API.CMS.CPRV.01 - the content previews of the current customer.
     * Read-only: content previews are provisioned via SQL seed only.
     */
    public async findContentPreviewOverview(): Promise<ContentPreviewOverviewRestDto[]> {
        const response: AxiosResponse<ContentPreviewOverviewResultsRestDto> =
            await this.apiService.getContentPreviewOverview();

        return response.data.results ?? [];
    }
}
